import {oceanBlueColor, grayColor} from '../../cmsMainStyle'

const saveWarnDialogStyle = theme => ({
	content: {
		color: grayColor[12]
	},

	actionButton: {
		color: oceanBlueColor[13],
		fontSize: 15,
		fontWeight: 600,
	}
})


export {saveWarnDialogStyle}